module.exports = __webpack_public_path__ + "img/speaker14.5098ef74.png";